<template>
  <div>
    <button @click="showModalDeleteBrand" class="flex center-flex-y">REMOVE ARTICLE</button>
    <modal-branddelete v-if="showBrandDeleteModal" :modal.sync="showBrandDeleteModal" :passedObject="objectToPass"></modal-branddelete>
  </div>
</template>

<script>
import Vue from "vue";
import ModalBranddelete from "./ModalBranddelete.vue";
  export default {
    name: 'modalDelbrand',
    props: {
      passedItem: {
          type: Object
      }
    },
    components: {ModalBranddelete},
    data: function() {
      return {
        showBrandDeleteModal:false,
        objectToPass: null,
      }
    },
    methods: {
      showModalDeleteBrand: function() {
        this.showBrandDeleteModal = true;
        this.objectToPass = this.$props.passedItem;
      },
    }
  }
</script>

<style>
.result em {
  background-color: #ccc;
  color:black;
}

</style>

<style scoped>
.flex-row {
  display:flex;
}
input {
  display:block;
}

@media screen and (min-width: $responsive_breakpoint_min) {
  .scrolling-wrapper-flexbox {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
}
@media screen and (max-width: $responsive_breakpoint_max) {
  .scrolling-wrapper-flexbox {
    overflow-x: scroll;
  }
}
.scrolling-wrapper-flexbox {
    display: flex;
    flex-wrap: nowrap;

    overflow-x:scroll;
    -webkit-overflow-scrolling: touch;
}
input {
      width: 500px;
}
</style>


// WEBPACK FOOTER //
// ModalDelbrand.vue?1bd2540f